import { Dispatch } from "react";

import { GET_POSITIONS_INFO, DELETE_POSITIONS_INFO } from "./types";
import { PaginationRequestType } from "@type/HRM/pagination";
import { PositionsResponseType } from "@type/HRM/position";

import api from "@helpers/api";

export type ErrorResponse = any;

// api url

const endPoint = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/unit-positions`;

export const getPositionsInfoRequest = (payload: PaginationRequestType) => {
  return {
    type: GET_POSITIONS_INFO.GET_POSITIONS_INFO_REQUEST,
    payload: { payload },
  } as const;
};

export const getPositionsInfoSuccess = (data: PositionsResponseType) => {
  return {
    type: GET_POSITIONS_INFO.GET_POSITIONS_INFO_SUCCESS,
    payload: { data },
  } as const;
};

export const getPositionsInfoFailed = () => {
  return {
    type: GET_POSITIONS_INFO.GET_POSITIONS_INFO_FAILED,
  } as const;
};

// delete actions type

export type DELETE_LOADING = {
  type: "POSITIONS_INFO_DELETE_LOADING";
  payload: boolean;
};

export type DELETE_SUCCESS = {
  type: "POSITIONS_INFO_DELETE_SUCCESS";
  payload: string;
};

export type DELETE_ERROR = {
  type: "POSITIONS_INFO_DELETE_ERROR";
  payload: ErrorResponse;
};

export type PositionsInfoActions =
  | ReturnType<typeof getPositionsInfoRequest>
  | ReturnType<typeof getPositionsInfoSuccess>
  | ReturnType<typeof getPositionsInfoFailed>
  | DELETE_LOADING
  | DELETE_SUCCESS
  | DELETE_ERROR;

// DELETE ACTION

export const deletePositionsInfo =
  (id: string | number) => async (dispatch: Dispatch<PositionsInfoActions>) => {
    dispatch({ type: DELETE_POSITIONS_INFO.LOADING, payload: true });

    try {
      const res = await api.delete(`${endPoint}/${id}`);

      dispatch({ type: DELETE_POSITIONS_INFO.SUCCESS, payload: id });
    } catch (err) {
      dispatch({ type: DELETE_POSITIONS_INFO.ERROR, payload: err });
    }
  };
